import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {NavigationProvider} from "./hooks/useNavigation";
import {ParallaxProvider} from "react-scroll-parallax";
import {AlertProvider} from "./hooks/useAlert";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <NavigationProvider>
      <AlertProvider>
      <ParallaxProvider>
      <App />
      </ParallaxProvider>
      </AlertProvider>
    </NavigationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
